module.exports = __webpack_public_path__ + "static/gains___losses.83a4c95b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/gains___losses.png
// module id = 466
// module chunks = 35783957827783